import { useState } from "react";
import styled from "styled-components";
import tramIcon from '../../../../assets/images/Tram_Icon_Transparent.svg';
import busIcon from '../../../../assets/images/busCircle.svg';
import { useDispatch, useSelector } from "react-redux";
import { TTransportType } from "../../types/types";
import { setTransportTypes } from "../../store/mapScreenSlce";
import { RootState } from "@/store/redux/store";

const SwitcherTransport = () => {
    const dispatch = useDispatch();
    const transportTypes = useSelector((state: RootState) => state.mapScreen.transportTypes);

    const toggleButton = (type: TTransportType) => {
        dispatch(setTransportTypes(type));
    };

    return (
        <div className="map-screen__switchers-panel">
            <Container>
                <Button active={transportTypes.includes('ТРАМВАЙ')} onClick={() => toggleButton('ТРАМВАЙ')} id="tram">
                    <Image src={tramIcon} alt="Трамваи" />
                </Button>
                <Button active={transportTypes.includes('АВТОБУС')} onClick={() => toggleButton('АВТОБУС')} id="bus">
                    <Image src={busIcon} alt="Автобусы" />
                </Button>
            </Container>
        </div>
    )
}

export default SwitcherTransport;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
`;

const Button = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
  transition: opacity 0.2s ease;
`;

const Image = styled.img`
  width: 35px;
  height: 35px;
`;